var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    _vm._b(
      {
        ref: "modal",
        staticClass: "flyerline-modal",
        attrs: {
          name: _vm.name,
          resizable: false,
          width: "100%",
          height: "auto",
          "max-width": 1024,
          adaptive: true,
          scrollable: true,
        },
        on: {
          closed: function ($event) {
            return _vm.$emit("closed")
          },
          "before-open": _vm.beforeOpen,
          "before-close": _vm.beforeClose,
        },
      },
      "modal",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { staticClass: "modal-close" }, [
        _c(
          "a",
          {
            staticClass:
              "fancy-close-flyerline d-flex align-items-center text-decoration-none text-white",
            attrs: { href: "javascript:;", title: "" },
            on: {
              click: function ($event) {
                return _vm.$modal.hide(_vm.name)
              },
            },
          },
          [
            _c("small", { staticClass: "text-white mr-2 font-weight-bold" }, [
              _vm._v(_vm._s(_vm._f("translate")("txtClose"))),
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "svg-icon",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 36 36",
                },
              },
              [
                _c("circle", {
                  attrs: { cx: "18", cy: "18", r: "18", fill: "#fff" },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M24.92 23.33L19.59 18l5.32-5.32c.44-.44.44-1.15 0-1.59-.44-.44-1.15-.44-1.59 0L18 16.41l-5.32-5.32c-.44-.44-1.15-.44-1.59 0-.44.44-.44 1.15 0 1.59L16.41 18l-5.32 5.32c-.44.44-.44 1.15 0 1.59.44.44 1.15.44 1.59 0L18 19.59l5.33 5.33c.44.44 1.15.44 1.59 0s.44-1.15 0-1.59z",
                    fill: "#3a3a39",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }